import { useTranslation } from 'react-i18next';
import { cn } from '@/utils/cn';

interface DayOfWeekSelectorProps {
  value: string[];
  onChange: (value: string[]) => void;
  disabled?: boolean;
  className?: string;
}

const DAYS = [
  { value: 'MONDAY', key: 'monday' },
  { value: 'TUESDAY', key: 'tuesday' },
  { value: 'WEDNESDAY', key: 'wednesday' },
  { value: 'THURSDAY', key: 'thursday' },
  { value: 'FRIDAY', key: 'friday' },
  { value: 'SATURDAY', key: 'saturday' },
  { value: 'SUNDAY', key: 'sunday' },
];

export function DayOfWeekSelector({ value, onChange, disabled, className }: DayOfWeekSelectorProps) {
  const { t } = useTranslation();

  const handleToggle = (day: string) => {
    if (disabled) return;

    const newValue = value.includes(day)
      ? value.filter(d => d !== day)
      : [...value, day];
    onChange(newValue);
  };

  return (
    <div className={cn('flex flex-wrap gap-2', className)}>
      {DAYS.map(day => {
        const isSelected = value.includes(day.value);
        return (
          <button
            key={day.value}
            type="button"
            onClick={() => handleToggle(day.value)}
            disabled={disabled}
            className={cn(
              'px-3 py-2 rounded-md text-sm font-medium transition-all',
              'border border-border',
              isSelected
                ? 'bg-accent text-accent-foreground border-accent'
                : 'bg-card text-foreground hover:bg-accent/10',
              disabled && 'opacity-50 cursor-not-allowed'
            )}
          >
            {t(`common.days.${day.key}`)}
          </button>
        );
      })}
    </div>
  );
}
